const scalesDict = {
  trumpet: {
    C4: [
      'C4',
      'D4',
      'E4',
      'F4',
      'G4',
      'A4',
      'B4',
      'C5',
      'B4',
      'A4',
      'G4',
      'F4',
      'E4',
      'D4',
      'C4',
    ],
    C5: [
      'C5',
      'D5',
      'E5',
      'F5',
      'G5',
      'A5',
      'B5',
      'C6',
      'B5',
      'A5',
      'G5',
      'F5',
      'E5',
      'D5',
      'C5',
    ],
    G3: [
      'G3',
      'A3',
      'B3',
      'C4',
      'D4',
      'E4',
      'F#4',
      'G4',
      'F#4',
      'E4',
      'D4',
      'C4',
      'B3',
      'A3',
      'G3',
    ],
    G4: [
      'G4',
      'A4',
      'B4',
      'C5',
      'D5',
      'E5',
      'F#5',
      'G5',
      'F#5',
      'E5',
      'D5',
      'C5',
      'B4',
      'A4',
      'G4',
    ],
    D4: [
      'D4',
      'E4',
      'F#4',
      'G4',
      'A4',
      'B4',
      'C#5',
      'D5',
      'C#5',
      'B4',
      'A4',
      'G4',
      'F#4',
      'E4',
      'D4',
    ],
    A3: [
      'A3',
      'B3',
      'C#4',
      'D4',
      'E4',
      'F#4',
      'G#4',
      'A4',
      'G#4',
      'F#4',
      'E4',
      'D4',
      'C#4',
      'B3',
      'A3',
    ],
    A4: [
      'A4',
      'B4',
      'C#5',
      'D5',
      'E5',
      'F#5',
      'G#5',
      'A5',
      'G#5',
      'F#5',
      'E5',
      'D5',
      'C#5',
      'B4',
      'A4',
    ],
    E4: [
      'E4',
      'F#4',
      'G#4',
      'A4',
      'B4',
      'C#5',
      'D#5',
      'E5',
      'D#5',
      'C#5',
      'B4',
      'A4',
      'G#4',
      'F#4',
      'E4',
    ],
    B3: [
      'B3',
      'C#4',
      'D#4',
      'E4',
      'F#4',
      'G#4',
      'A#4',
      'B4',
      'A#4',
      'G#4',
      'F#4',
      'E4',
      'D#4',
      'C#4',
      'B3',
    ],
    B4: [
      'B4',
      'C#5',
      'D#5',
      'E5',
      'F#5',
      'G#5',
      'A#5',
      'B5',
      'A#5',
      'G#5',
      'F#5',
      'E5',
      'D#5',
      'C#5',
      'B4',
    ],
    'F#3': [
      'F#3',
      'G#3',
      'A#3',
      'B3',
      'C#4',
      'D#4',
      'E#4',
      'F#4',
      'E#4',
      'D#4',
      'C#4',
      'B3',
      'A#3',
      'G#3',
      'F#3',
    ],
    'F#4': [
      'F#4',
      'G#4',
      'A#4',
      'B4',
      'C#5',
      'D#5',
      'E#5',
      'F#5',
      'E#5',
      'D#5',
      'C#5',
      'B4',
      'A#4',
      'G#4',
      'F#4',
    ],
    'C#4': [
      'C#4',
      'D#4',
      'E#4',
      'F#4',
      'G#4',
      'A#4',
      'B#4',
      'C#5',
      'B#4',
      'A#4',
      'G#4',
      'F#4',
      'E#4',
      'D#4',
      'C#4',
    ],
    Ab3: [
      'Ab3',
      'Bb3',
      'C4',
      'Db4',
      'Eb4',
      'F4',
      'G4',
      'Ab4',
      'G4',
      'F4',
      'Eb4',
      'Db4',
      'C4',
      'Bb3',
      'Ab3',
    ],
    Ab4: [
      'Ab4',
      'Bb4',
      'C5',
      'Db5',
      'Eb5',
      'F5',
      'G5',
      'Ab5',
      'G5',
      'F5',
      'Eb5',
      'Db5',
      'C5',
      'Bb4',
      'Ab4',
    ],
    Eb4: [
      'Eb4',
      'F4',
      'G4',
      'Ab4',
      'Bb4',
      'C5',
      'D5',
      'Eb5',
      'D5',
      'C5',
      'Bb4',
      'Ab4',
      'G4',
      'F4',
      'Eb4',
    ],
    Bb3: [
      'Bb3',
      'C4',
      'D4',
      'Eb4',
      'F4',
      'G4',
      'A4',
      'Bb4',
      'A4',
      'G4',
      'F4',
      'Eb4',
      'D4',
      'C4',
      'Bb3',
    ],
    Bb4: [
      'Bb4',
      'C5',
      'D5',
      'Eb5',
      'F5',
      'G5',
      'A5',
      'Bb5',
      'A5',
      'G5',
      'F5',
      'Eb5',
      'D5',
      'C5',
      'Bb4',
    ],
    F4: [
      'F4',
      'G4',
      'A4',
      'Bb4',
      'C5',
      'D5',
      'E5',
      'F5',
      'E5',
      'D5',
      'C5',
      'Bb4',
      'A4',
      'G4',
      'F4',
    ],
  },
  frenchHorn: {
    C4: [
      'C4',
      'D4',
      'E4',
      'F4',
      'G4',
      'A4',
      'B4',
      'C5',
      'B4',
      'A4',
      'G4',
      'F4',
      'E4',
      'D4',
      'C4',
    ],
    C5: [
      'C5',
      'D5',
      'E5',
      'F5',
      'G5',
      'A5',
      'B5',
      'C6',
      'B5',
      'A5',
      'G5',
      'F5',
      'E5',
      'D5',
      'C5',
    ],
    G3: [
      'G3',
      'A3',
      'B3',
      'C4',
      'D4',
      'E4',
      'F#4',
      'G4',
      'F#4',
      'E4',
      'D4',
      'C4',
      'B3',
      'A3',
      'G3',
    ],
    G4: [
      'G4',
      'A4',
      'B4',
      'C5',
      'D5',
      'E5',
      'F#5',
      'G5',
      'F#5',
      'E5',
      'D5',
      'C5',
      'B4',
      'A4',
      'G4',
    ],
    D4: [
      'D4',
      'E4',
      'F#4',
      'G4',
      'A4',
      'B4',
      'C#5',
      'D5',
      'C#5',
      'B4',
      'A4',
      'G4',
      'F#4',
      'E4',
      'D4',
    ],
    A3: [
      'A3',
      'B3',
      'C#4',
      'D4',
      'E4',
      'F#4',
      'G#4',
      'A4',
      'G#4',
      'F#4',
      'E4',
      'D4',
      'C#4',
      'B3',
      'A3',
    ],
    A4: [
      'A4',
      'B4',
      'C#5',
      'D5',
      'E5',
      'F#5',
      'G#5',
      'A5',
      'G#5',
      'F#5',
      'E5',
      'D5',
      'C#5',
      'B4',
      'A4',
    ],
    E4: [
      'E4',
      'F#4',
      'G#4',
      'A4',
      'B4',
      'C#5',
      'D#5',
      'E5',
      'D#5',
      'C#5',
      'B4',
      'A4',
      'G#4',
      'F#4',
      'E4',
    ],
    B3: [
      'B3',
      'C#4',
      'D#4',
      'E4',
      'F#4',
      'G#4',
      'A#4',
      'B4',
      'A#4',
      'G#4',
      'F#4',
      'E4',
      'D#4',
      'C#4',
      'B3',
    ],
    B4: [
      'B4',
      'C#5',
      'D#5',
      'E5',
      'F#5',
      'G#5',
      'A#5',
      'B5',
      'A#5',
      'G#5',
      'F#5',
      'E5',
      'D#5',
      'C#5',
      'B4',
    ],
    'F#3': [
      'F#3',
      'G#3',
      'A#3',
      'B3',
      'C#4',
      'D#4',
      'E#4',
      'F#4',
      'E#4',
      'D#4',
      'C#4',
      'B3',
      'A#3',
      'G#3',
      'F#3',
    ],
    'F#4': [
      'F#4',
      'G#4',
      'A#4',
      'B4',
      'C#5',
      'D#5',
      'E#5',
      'F#5',
      'E#5',
      'D#5',
      'C#5',
      'B4',
      'A#4',
      'G#4',
      'F#4',
    ],
    'C#4': [
      'C#4',
      'D#4',
      'E#4',
      'F#4',
      'G#4',
      'A#4',
      'B#4',
      'C#5',
      'B#4',
      'A#4',
      'G#4',
      'F#4',
      'E#4',
      'D#4',
      'C#4',
    ],
    Ab3: [
      'Ab3',
      'Bb3',
      'C4',
      'Db4',
      'Eb4',
      'F4',
      'G4',
      'Ab4',
      'G4',
      'F4',
      'Eb4',
      'Db4',
      'C4',
      'Bb3',
      'Ab3',
    ],
    Ab4: [
      'Ab4',
      'Bb4',
      'C5',
      'Db5',
      'Eb5',
      'F5',
      'G5',
      'Ab5',
      'G5',
      'F5',
      'Eb5',
      'Db5',
      'C5',
      'Bb4',
      'Ab4',
    ],
    Eb4: [
      'Eb4',
      'F4',
      'G4',
      'Ab4',
      'Bb4',
      'C5',
      'D5',
      'Eb5',
      'D5',
      'C5',
      'Bb4',
      'Ab4',
      'G4',
      'F4',
      'Eb4',
    ],
    Bb3: [
      'Bb3',
      'C4',
      'D4',
      'Eb4',
      'F4',
      'G4',
      'A4',
      'Bb4',
      'A4',
      'G4',
      'F4',
      'Eb4',
      'D4',
      'C4',
      'Bb3',
    ],
    Bb4: [
      'Bb4',
      'C5',
      'D5',
      'Eb5',
      'F5',
      'G5',
      'A5',
      'Bb5',
      'A5',
      'G5',
      'F5',
      'Eb5',
      'D5',
      'C5',
      'Bb4',
    ],
    F3: [
      'F3',
      'G3',
      'A3',
      'Bb3',
      'C4',
      'D4',
      'E4',
      'F4',
      'E4',
      'D4',
      'C4',
      'Bb3',
      'A3',
      'G3',
      'F3',
    ],
    F4: [
      'F4',
      'G4',
      'A4',
      'Bb4',
      'C5',
      'D5',
      'E5',
      'F5',
      'E5',
      'D5',
      'C5',
      'Bb4',
      'A4',
      'G4',
      'F4',
    ],
  },

  trombone: {
    Bb2: [
      'Bb2',
      'C3',
      'D3',
      'Eb3',
      'F3',
      'G3',
      'A3',
      'Bb3',
      'A3',
      'G3',
      'F3',
      'Eb3',
      'D3',
      'C3',
      'Bb2',
    ],
    Bb3: [
      'Bb3',
      'C4',
      'D4',
      'Eb4',
      'F4',
      'G4',
      'A4',
      'Bb4',
      'A4',
      'G4',
      'F4',
      'Eb4',
      'D4',
      'C4',
      'Bb3',
    ],
    F2: [
      'F2',
      'G2',
      'A2',
      'Bb2',
      'C3',
      'D3',
      'E3',
      'F3',
      'E3',
      'D3',
      'C3',
      'Bb2',
      'A2',
      'G2',
      'F2',
    ],
    F3: [
      'F3',
      'G3',
      'A3',
      'Bb3',
      'C4',
      'D4',
      'E4',
      'F4',
      'E4',
      'D4',
      'C4',
      'Bb3',
      'A3',
      'G3',
      'F3',
    ],
    C3: [
      'C3',
      'D3',
      'E3',
      'F3',
      'G3',
      'A3',
      'B3',
      'C4',
      'B3',
      'A3',
      'G3',
      'F3',
      'E3',
      'D3',
      'C3',
    ],
    G2: [
      'G2',
      'A2',
      'B2',
      'C3',
      'D3',
      'E3',
      'F#3',
      'G3',
      'F#3',
      'E3',
      'D3',
      'C3',
      'B2',
      'A2',
      'G2',
    ],
    G3: [
      'G3',
      'A3',
      'B3',
      'C4',
      'D4',
      'E4',
      'F#4',
      'G4',
      'F#4',
      'E4',
      'D4',
      'C4',
      'B3',
      'A3',
      'G3',
    ],
    D3: [
      'D3',
      'E3',
      'F#3',
      'G3',
      'A3',
      'B3',
      'C#4',
      'D4',
      'C#4',
      'B3',
      'A3',
      'G3',
      'F#3',
      'E3',
      'D3',
    ],
    A2: [
      'A2',
      'B2',
      'C#3',
      'D3',
      'E3',
      'F#3',
      'G#3',
      'A3',
      'G#3',
      'F#3',
      'E3',
      'D3',
      'C#3',
      'B2',
      'A2',
    ],
    A3: [
      'A3',
      'B3',
      'C#4',
      'D4',
      'E4',
      'F#4',
      'G#4',
      'A4',
      'G#4',
      'F#4',
      'E4',
      'D4',
      'C#4',
      'B3',
      'A3',
    ],
    E2: [
      'E2',
      'F#2',
      'G#2',
      'A2',
      'B2',
      'C#3',
      'D#3',
      'E3',
      'D#3',
      'C#3',
      'B2',
      'A2',
      'G#2',
      'F#2',
      'E2',
    ],
    E3: [
      'E3',
      'F#3',
      'G#3',
      'A3',
      'B3',
      'C#4',
      'D#4',
      'E4',
      'D#4',
      'C#4',
      'B3',
      'A3',
      'G#3',
      'F#3',
      'E3',
    ],
    B2: [
      'B2',
      'C#3',
      'D#3',
      'E3',
      'F#3',
      'G#3',
      'A#3',
      'B3',
      'A#3',
      'G#3',
      'F#3',
      'E3',
      'D#3',
      'C#3',
      'B2',
    ],
    B3: [
      'B3',
      'C#4',
      'D#4',
      'E4',
      'F#4',
      'G#4',
      'A#4',
      'B4',
      'A#4',
      'G#4',
      'F#4',
      'E4',
      'D#4',
      'C#4',
      'B3',
    ],
    Gb2: [
      'Gb2',
      'Ab2',
      'Bb2',
      'Cb3',
      'Db3',
      'Eb3',
      'F3',
      'Gb3',
      'F3',
      'Eb3',
      'Db3',
      'Cb3',
      'Bb2',
      'Ab2',
      'Gb2',
    ],
    Gb3: [
      'Gb3',
      'Ab3',
      'Bb3',
      'Cb4',
      'Db4',
      'Eb4',
      'F4',
      'Gb4',
      'F4',
      'Eb4',
      'Db4',
      'Cb4',
      'Bb3',
      'Ab3',
      'Gb3',
    ],
    Db3: [
      'Db3',
      'Eb3',
      'F3',
      'Gb3',
      'Ab3',
      'Bb3',
      'C4',
      'Db4',
      'C4',
      'Bb3',
      'Ab3',
      'Gb3',
      'F3',
      'Eb3',
      'Db3',
    ],
    Ab2: [
      'Ab2',
      'Bb2',
      'C3',
      'Db3',
      'Eb3',
      'F3',
      'G3',
      'Ab3',
      'G3',
      'F3',
      'Eb3',
      'Db3',
      'C3',
      'Bb2',
      'Ab2',
    ],
    Ab3: [
      'Ab3',
      'Bb3',
      'C4',
      'Db4',
      'Eb4',
      'F4',
      'G4',
      'Ab4',
      'G4',
      'F4',
      'Eb4',
      'Db4',
      'C4',
      'Bb3',
      'Ab3',
    ],
    Eb3: [
      'Eb3',
      'F3',
      'G3',
      'Ab3',
      'Bb3',
      'C4',
      'D4',
      'Eb4',
      'D4',
      'C4',
      'Bb3',
      'Ab3',
      'G3',
      'F3',
      'Eb3',
    ],
  },
  euphonium: {
    Bb2: [
      'Bb2',
      'C3',
      'D3',
      'Eb3',
      'F3',
      'G3',
      'A3',
      'Bb3',
      'A3',
      'G3',
      'F3',
      'Eb3',
      'D3',
      'C3',
      'Bb2',
    ],
    Bb3: [
      'Bb3',
      'C4',
      'D4',
      'Eb4',
      'F4',
      'G4',
      'A4',
      'Bb4',
      'A4',
      'G4',
      'F4',
      'Eb4',
      'D4',
      'C4',
      'Bb3',
    ],
    F2: [
      'F2',
      'G2',
      'A2',
      'Bb2',
      'C3',
      'D3',
      'E3',
      'F3',
      'E3',
      'D3',
      'C3',
      'Bb2',
      'A2',
      'G2',
      'F2',
    ],
    F3: [
      'F3',
      'G3',
      'A3',
      'Bb3',
      'C4',
      'D4',
      'E4',
      'F4',
      'E4',
      'D4',
      'C4',
      'Bb3',
      'A3',
      'G3',
      'F3',
    ],
    C3: [
      'C3',
      'D3',
      'E3',
      'F3',
      'G3',
      'A3',
      'B3',
      'C4',
      'B3',
      'A3',
      'G3',
      'F3',
      'E3',
      'D3',
      'C3',
    ],
    G2: [
      'G2',
      'A2',
      'B2',
      'C3',
      'D3',
      'E3',
      'F#3',
      'G3',
      'F#3',
      'E3',
      'D3',
      'C3',
      'B2',
      'A2',
      'G2',
    ],
    G3: [
      'G3',
      'A3',
      'B3',
      'C4',
      'D4',
      'E4',
      'F#4',
      'G4',
      'F#4',
      'E4',
      'D4',
      'C4',
      'B3',
      'A3',
      'G3',
    ],
    D3: [
      'D3',
      'E3',
      'F#3',
      'G3',
      'A3',
      'B3',
      'C#4',
      'D4',
      'C#4',
      'B3',
      'A3',
      'G3',
      'F#3',
      'E3',
      'D3',
    ],
    A2: [
      'A2',
      'B2',
      'C#3',
      'D3',
      'E3',
      'F#3',
      'G#3',
      'A3',
      'G#3',
      'F#3',
      'E3',
      'D3',
      'C#3',
      'B2',
      'A2',
    ],
    A3: [
      'A3',
      'B3',
      'C#4',
      'D4',
      'E4',
      'F#4',
      'G#4',
      'A4',
      'G#4',
      'F#4',
      'E4',
      'D4',
      'C#4',
      'B3',
      'A3',
    ],
    E2: [
      'E2',
      'F#2',
      'G#2',
      'A2',
      'B2',
      'C#3',
      'D#3',
      'E3',
      'D#3',
      'C#3',
      'B2',
      'A2',
      'G#2',
      'F#2',
      'E2',
    ],
    E3: [
      'E3',
      'F#3',
      'G#3',
      'A3',
      'B3',
      'C#4',
      'D#4',
      'E4',
      'D#4',
      'C#4',
      'B3',
      'A3',
      'G#3',
      'F#3',
      'E3',
    ],
    B2: [
      'B2',
      'C#3',
      'D#3',
      'E3',
      'F#3',
      'G#3',
      'A#3',
      'B3',
      'A#3',
      'G#3',
      'F#3',
      'E3',
      'D#3',
      'C#3',
      'B2',
    ],
    B3: [
      'B3',
      'C#4',
      'D#4',
      'E4',
      'F#4',
      'G#4',
      'A#4',
      'B4',
      'A#4',
      'G#4',
      'F#4',
      'E4',
      'D#4',
      'C#4',
      'B3',
    ],
    Gb2: [
      'Gb2',
      'Ab2',
      'Bb2',
      'Cb3',
      'Db3',
      'Eb3',
      'F3',
      'Gb3',
      'F3',
      'Eb3',
      'Db3',
      'Cb3',
      'Bb2',
      'Ab2',
      'Gb2',
    ],
    Gb3: [
      'Gb3',
      'Ab3',
      'Bb3',
      'Cb4',
      'Db4',
      'Eb4',
      'F4',
      'Gb4',
      'F4',
      'Eb4',
      'Db4',
      'Cb4',
      'Bb3',
      'Ab3',
      'Gb3',
    ],
    Db3: [
      'Db3',
      'Eb3',
      'F3',
      'Gb3',
      'Ab3',
      'Bb3',
      'C4',
      'Db4',
      'C4',
      'Bb3',
      'Ab3',
      'Gb3',
      'F3',
      'Eb3',
      'Db3',
    ],
    Ab2: [
      'Ab2',
      'Bb2',
      'C3',
      'Db3',
      'Eb3',
      'F3',
      'G3',
      'Ab3',
      'G3',
      'F3',
      'Eb3',
      'Db3',
      'C3',
      'Bb2',
      'Ab2',
    ],
    Ab3: [
      'Ab3',
      'Bb3',
      'C4',
      'Db4',
      'Eb4',
      'F4',
      'G4',
      'Ab4',
      'G4',
      'F4',
      'Eb4',
      'Db4',
      'C4',
      'Bb3',
      'Ab3',
    ],
    Eb3: [
      'Eb3',
      'F3',
      'G3',
      'Ab3',
      'Bb3',
      'C4',
      'D4',
      'Eb4',
      'D4',
      'C4',
      'Bb3',
      'Ab3',
      'G3',
      'F3',
      'Eb3',
    ],
  },
  tuba: {
    Bb1: [
      'Bb1',
      'C2',
      'D2',
      'Eb2',
      'F2',
      'G2',
      'A2',
      'Bb2',
      'A2',
      'G2',
      'F2',
      'Eb2',
      'D2',
      'C2',
      'Bb1',
    ],
    Bb2: [
      'Bb2',
      'C3',
      'D3',
      'Eb3',
      'F3',
      'G3',
      'A3',
      'Bb3',
      'A3',
      'G3',
      'F3',
      'Eb3',
      'D3',
      'C3',
      'Bb2',
    ],
    F1: [
      'F1',
      'G1',
      'A1',
      'Bb1',
      'C2',
      'D2',
      'E2',
      'F2',
      'E2',
      'D2',
      'C2',
      'Bb1',
      'A1',
      'G1',
      'F1',
    ],
    F2: [
      'F2',
      'G2',
      'A2',
      'Bb2',
      'C3',
      'D3',
      'E3',
      'F3',
      'E3',
      'D3',
      'C3',
      'Bb2',
      'A2',
      'G2',
      'F2',
    ],
    C2: [
      'C2',
      'D2',
      'E2',
      'F2',
      'G2',
      'A2',
      'B2',
      'C3',
      'B2',
      'A2',
      'G2',
      'F2',
      'E2',
      'D2',
      'C2',
    ],
    G1: [
      'G1',
      'A1',
      'B1',
      'C2',
      'D2',
      'E2',
      'F#2',
      'G2',
      'F#2',
      'E2',
      'D2',
      'C2',
      'B1',
      'A1',
      'G1',
    ],
    G2: [
      'G2',
      'A2',
      'B2',
      'C3',
      'D3',
      'E3',
      'F#3',
      'G3',
      'F#3',
      'E3',
      'D3',
      'C3',
      'B2',
      'A2',
      'G2',
    ],
    D2: [
      'D2',
      'E2',
      'F#2',
      'G2',
      'A2',
      'B2',
      'C#3',
      'D3',
      'C#3',
      'B2',
      'A2',
      'G2',
      'F#2',
      'E2',
      'D2',
    ],
    A1: [
      'A1',
      'B1',
      'C#2',
      'D2',
      'E2',
      'F#2',
      'G#2',
      'A2',
      'G#2',
      'F#2',
      'E2',
      'D2',
      'C#2',
      'B1',
      'A1',
    ],
    A2: [
      'A2',
      'B2',
      'C#3',
      'D3',
      'E3',
      'F#3',
      'G#3',
      'A3',
      'G#3',
      'F#3',
      'E3',
      'D3',
      'C#3',
      'B2',
      'A2',
    ],
    E1: [
      'E1',
      'F#1',
      'G#1',
      'A1',
      'B1',
      'C#2',
      'D#2',
      'E2',
      'D#2',
      'C#2',
      'B1',
      'A1',
      'G#1',
      'F#1',
      'E1',
    ],
    E2: [
      'E2',
      'F#2',
      'G#2',
      'A2',
      'B2',
      'C#3',
      'D#3',
      'E3',
      'D#3',
      'C#3',
      'B2',
      'A2',
      'G#2',
      'F#2',
      'E2',
    ],
    B1: [
      'B1',
      'C#2',
      'D#2',
      'E2',
      'F#2',
      'G#2',
      'A#2',
      'B2',
      'A#2',
      'G#2',
      'F#2',
      'E2',
      'D#2',
      'C#2',
      'B1',
    ],
    B2: [
      'B2',
      'C#3',
      'D#3',
      'E3',
      'F#3',
      'G#3',
      'A#3',
      'B3',
      'A#3',
      'G#3',
      'F#3',
      'E3',
      'D#3',
      'C#3',
      'B2',
    ],
    Gb1: [
      'Gb1',
      'Ab1',
      'Bb1',
      'Cb2',
      'Db2',
      'Eb2',
      'F2',
      'Gb2',
      'F2',
      'Eb2',
      'Db2',
      'Cb2',
      'Bb1',
      'Ab1',
      'Gb1',
    ],
    Gb2: [
      'Gb2',
      'Ab2',
      'Bb2',
      'Cb3',
      'Db3',
      'Eb3',
      'F3',
      'Gb3',
      'F3',
      'Eb3',
      'Db3',
      'Cb3',
      'Bb2',
      'Ab2',
      'Gb2',
    ],
    Db2: [
      'Db2',
      'Eb2',
      'F2',
      'Gb2',
      'Ab2',
      'Bb2',
      'C3',
      'Db3',
      'C3',
      'Bb2',
      'Ab2',
      'Gb2',
      'F2',
      'Eb2',
      'Db2',
    ],
    Ab1: [
      'Ab1',
      'Bb1',
      'C2',
      'Db2',
      'Eb2',
      'F2',
      'G2',
      'Ab2',
      'G2',
      'F2',
      'Eb2',
      'Db2',
      'C2',
      'Bb1',
      'Ab1',
    ],
    Ab2: [
      'Ab2',
      'Bb2',
      'C3',
      'Db3',
      'Eb3',
      'F3',
      'G3',
      'Ab3',
      'G3',
      'F3',
      'Eb3',
      'Db3',
      'C3',
      'Bb2',
      'Ab2',
    ],
    Eb2: [
      'Eb2',
      'F2',
      'G2',
      'Ab2',
      'Bb2',
      'C3',
      'D3',
      'Eb3',
      'D3',
      'C3',
      'Bb2',
      'Ab2',
      'G2',
      'F2',
      'Eb2',
    ],
  },
};

export { scalesDict };
